( function( $ ) {
  /**
   * Compute the position of the arrow
   * by getting the full width of the browser
   * and use the width of the header. 
   * 
   * Then get the difference between that two width
   * and divide it into 2 and add extra space which is 15.
   * 
   * Then place the divided width in the two arrows.
   * 
   * @var int
   */
  // var arrow_h_pos = ( ( $( window ).width() - $( 'header .row' ).width() ) / 2 ) + 15;
  // $( '.__hero_slider .swiper-button-prev' ).css( 'left', arrow_h_pos + 'px' );
  // $( '.__hero_slider .swiper-button-next' ).css( 'right', arrow_h_pos + 'px' );
  // $( window ).on( 'resize', function() {
  //   arrow_h_pos = ( ( $( window ).width() - $( 'header .row' ).width() ) / 2 ) + 15;
  //   $( '.__hero_slider .swiper-button-prev' ).css( 'left', arrow_h_pos + 'px' );
  //   $( '.__hero_slider .swiper-button-next' ).css( 'right', arrow_h_pos + 'px' );
  // } );

  /**
   * Initialize hero slider
   */
  $( '.__hero_slider' ).each( function() {
    if ( $( this ).hasClass( '__slides' ) ) {
      new Swiper( $( this ), {
        centeredSlides: true,
        speed: 1500,
        autoplay: {
          delay: 4000,
        },
        loop: true,
        // navigation: {
        //   nextEl: '.hero-next',
        //   prevEl: '.hero-prev',
        // },
        pagination: {
          el: '.swiper-pagination',
          type: 'bullets',
          clickable: true
        },
      } );
    }
  } );
} ) ( jQuery );